import { useLang } from 'hooks/lang';

import { Column, Row } from 'components/Blocks';

import { CheckIcon, DollarBillIcon, XIcon } from 'components/Icons';

import { StatusInfoComponent } from './types';

export const WaitingInfo: StatusInfoComponent = ({ control }) => {
  const { t } = useLang();

  const { readyToInvoice, type } = control;

  return (
    <Column gap="2">
      <Row gap="2">
        {readyToInvoice ? (
          <>
            <CheckIcon color="success-light" size={20} />

            <span className="text-sm text-success-light">{t('ready-to-be-invoiced')}</span>
          </>
        ) : (
          <>
            <XIcon size={20} />

            <span className="text-sm">{t('waiting-to-be-sent')}</span>
          </>
        )}
      </Row>

      <Row gap="2">
        <DollarBillIcon size={20} />

        <span className="text-sm">
          {type ? (
            <>
              <strong>{type}</strong>
            </>
          ) : (
            <>{t('no-payment-method')}</>
          )}
        </span>
      </Row>
    </Column>
  );
};
